import { Injectable } from '@angular/core';
import { RecaptchaLoaderService } from './recaptcha-loader.service';

declare const grecaptcha: any;

@Injectable({
  providedIn: 'root'
})
export class RecaptchaService {

  private siteKey = '6Lc02vIrAAAAACAkT-sOM3jb_t2AegADBSYbpqe7';

  constructor(
    private recaptchaLoader: RecaptchaLoaderService
  ) {}

  async getToken(action: string): Promise<string> {

    // Load reCAPTCHA script only once
    await this.recaptchaLoader.load(this.siteKey);

    return new Promise((resolve, reject) => {

      grecaptcha.ready(() => {

        grecaptcha.execute(this.siteKey, { action })
          .then(resolve)
          .catch(reject);

      });

    });

  }
}